export default "__VITE_ASSET__BqHNPa5C__"